import { app } from '../../../../../../app';
import { Controller } from './edit-shared-folder.controller';

app.component('companySharingCenterSharedFoldersManageEdit', {
    bindings: {
        companyId: '<',
        sharedFolder: '<',
        items: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-shared-folder.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/edit/edit-shared-folder.component..js